import React, { useEffect, useState } from 'react';
import {
  Container,
  makeStyles,
} from '@material-ui/core';
import Page from 'components/Page';

import { Header } from 'components';


import serviciosCatalogo from 'utils/serviciosCatalogo'
import CuerpoCatalogo from './Components/CuerpoCatalogo';
import Formulario from './Components/FormularioUsuario';
import getErrorMessage from 'utils/getErrorMessage';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3), 
    paddingTop: theme.spacing(3)
  },
}));

const Usuario = ({permisos,usuario}) => {
  const classes = useStyles();
  const {register,unregister,errors,handleSubmit,watch,setValue, getValues}=useForm();
  const [data,setData]=useState([]);
  const [cargando,setCargando]=useState(false);
  const [mensaje,setMensaje]=useState({open:false});
  const [modal,setModal]=useState({open:false});
  const [ctl,setCtl]=useState({rol:[], proyecto:[]});
  const [mAdvertencia,setMAdvertencia]=useState({open:false});
  const cambioEstatusFila=(item)=>(event)=>{clickBaja(event.target.checked)([item])()};
  const servicios={
    get:()=>serviciosCatalogo.usuariosAll(ct=>{
      setData(ct.data);
      setCtl({rol:ct.roles, proyecto:ct.proyectos});
  },setCargando),
    insert:(data)=>serviciosCatalogo.usuariosCreate(respuesta(cerrarModal),setCargando,data),
    update:(data)=>serviciosCatalogo.usuariosUpdate(respuesta(cerrarModal),setCargando,data),
    baja:(data)=>serviciosCatalogo.usuariosDown(respuesta(()=>{}),setCargando,data)
  }
  const clickBaja=(estatus)=>(seleccionados)=>()=>setMAdvertencia({
    open:true,
    paddingDisabled:false,
    titulo:"Advertencia",
    // mensaje:(seleccionados.length > 1 ? seleccionados.length+' Elementos seleccionados serán dados de '+(estatus?'alta':'baja')+', ¿Está seguro de continuar?' : seleccionados.length+' Elemento seleccionado será dado de '+(estatus?'alta':'baja')+', ¿Está seguro de continuar?'),
    mensaje:(seleccionados.length > 0 ? seleccionados.length+' Elementos seleccionados serán dados de '+(estatus?'alta':'baja')+', ¿Está seguro de continuar?' : seleccionados.length+' Elemento seleccionado será dado de '+(estatus?'alta':'baja')+', ¿Está seguro de continuar?'),
    aceptar:()=>servicios.baja({estatus:estatus,ids:seleccionados.map(i=>i["idusuario"])}),
  });
  const cerrarModal=()=>setModal({open:false});
  const cerrarAdvertencia=()=>setMAdvertencia({open:false});
  const respuesta=onSuccess=>(status,mensaje,data)=>{
    if(status>0){
      onSuccess();
      setData(data)
    }
    setMensaje({open:true,status:status,value:mensaje});
    cerrarAdvertencia();
  }
  const cerrarMensaje=()=>setMensaje({...mensaje,open:false});
  const columns=[
    {label:'NOMBRE',name:"npersona",filtrar:true},
    {label:'ROL',name:"nrol",filtrar:true},
    {label:'ESTATUS',name:"nombreEstatus",filtrar:true},
    {
      label:'ESTATUS',name:"idestatus",filtrar:true,
      type:{type:'switch',accion:cambioEstatusFila, active:"9"}
    },
  ]

  useEffect(()=>{
    if(getValues('rol')?.idrol){
      // unregister('proyecto');
      if(getValues('rol')?.idrol == 6){
        register("proyecto",{required:{value:true,message:'Campo requerido'},
        validate: (value) => value.length || 'Campo requerido'});
      }else{
        register("proyecto",null);
      }
    }
  },[getValues('rol')]);

  useEffect(()=>{ 
    if(modal.open&&modal.item)
    {
      setValue("rol",modal.item.idrol?{
        idrol:modal.item.idrol,
        nrol:modal.item.nrol}:null
      );

      if(modal.item?.idrol == 6){
        register("proyecto",{required:{value:true,message:'Campo requerido'},
        validate: (value) => value.length || 'Campo requerido'});
      }

      let arrayproy = modal.item.idproyectos.split(',');
      let newarray = ctl.proyecto.filter(function(val) {
        return arrayproy.includes(val.idproyecto.toString()) ;
      });
      setValue("proyecto", newarray);      
    }else{
      setValue("rol", null);
      setValue("proyecto", null);
    }
    
  },[modal])

  useEffect(()=>{
    register("rol",{required:{value:true,message:'Campo requerido'}});
    // register("proyecto",null);
  },[register]);

  useEffect(()=>{
    servicios.get(setData,setCargando);
  },[])
  return (
    <Page
      className={classes.root}
      title="Usuarios"
      mensaje={{...mensaje,cerrar:cerrarMensaje}}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="CATÁLOGO" subtitle="USUARIOS"/>
        <CuerpoCatalogo
          keyTabla='catUser'
          servicios={servicios}
          permisos={permisos}
          columns={columns}
          data={data}
          id='idusuario'
          modal={modal}
          catalogo='USUARIO'
          setModal={setModal}
          mAdvertencia={mAdvertencia}
          setMAdvertencia={setMAdvertencia}
          handleSubmit={handleSubmit}
          form={<Formulario 
            register={register} 
            ctl={ctl}
            setValue={setValue} 
            watch={watch}
            getValues={getValues}
            errors={getErrorMessage(errors)}
            defaultItem={modal.item||{}}
          />}
        />
      </Container>  
    </Page>
  );
};

export default Usuario;